export default {
  path: 'people',
  name: 'people',
  component: () => import('@/views/users/index.vue'),
  meta: {
    locale: '人员管理',
    requiresAuth: true,
    icon: 'icon-user-group',
  },
  children: [
    {
      path: 'user-list',
      name: 'userList',
      component: () => import('@/views/users/list/index.vue'),
      meta: {
        locale: '用户列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'biggie-list',
      name: 'biggieList',
      component: () => import('@/views/biggie/list/index.vue'),
      meta: {
        locale: '陪玩列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
    {
      path: 'biggie-boss',
      name: 'biggieBossList',
      component: () => import('@/views/biggie-boss/list/index.vue'),
      meta: {
        locale: '陪玩特殊分成比',
        requiresAuth: true,
        roles: ['super', 'admin'],
      },
    },
    {
      path: 'boss-service-list',
      name: 'boss-service-list',
      component: () => import('@/views/boss-service/list/index.vue'),
      meta: {
        locale: '专属客服列表',
        requiresAuth: true,
        roles: ['super', 'admin', 'service', 'special_service', 'treasurer'],
      },
    },
  ],
};
